/**
 * Breadcrumbs block
 *
 * UI for handling the logic and animations of breadcrumbs block
 */

const $ = require( 'jquery' );
const _ = require('lodash');

var itblBreadcrumbs = function(el){

  //setup some variables
  this.$el      = $(el);

  this.init();
};

itblBreadcrumbs.prototype.init = function(){

  this.events();
  this.setTopPosition();
  this.createEvent();

  $(window).on('resize', _.debounce(() => {
    this.setTopPosition();
  }, 300));

};

itblBreadcrumbs.prototype.events = function(){
  window.addEventListener('positionBreadcrumbs', function () {
    this.setTopPosition();
  }.bind(this), false);
};

itblBreadcrumbs.prototype.setTopPosition = function(){
    // Check if sticky enabled
    if(this.$el.hasClass('sticky')) {
        // Get the height of the header
        var headerHeight = $('header').height();

        // Check if logged if so, add the admin bar height
        if($('body').hasClass('admin-bar')) {
          if((window.innerWidth < 768 && !$('header').hasClass('is-scrolled')) || window.innerWidth >= 768) {
            headerHeight += $('#wpadminbar').height();
          }
        }

        // Set the top position
        this.$el.css('top', headerHeight-1);
    }
}

$(function(){
  $('.itbl-b-breadcrumbs').each(function(){
    new itblBreadcrumbs(this);
  });
});
